import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiX,
  FiLogOut,
  FiUserPlus,
  FiUser,
  FiHome,
  FiHelpCircle,
  FiInfo,
  FiChevronDown
} from "react-icons/fi";
import LoginModal from "./LoginModal"; 
import logo from "../assets/img/logo.png";

function Topbar() {
  const navigate = useNavigate();

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [showLogin, setShowLogin] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);

 
  
  useEffect(() => {
    const handleStorageChange = () =>
      setToken(localStorage.getItem("token"));
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const logoutNow = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    localStorage.removeItem("useremail");
    setToken(null);
    setShowLogoutConfirm(false);
    navigate("/");
  };

  return (

    <>

 

    <header className="sticky-top">

      {/* TOP NAV */}
      <nav className="topbar shadow-sm ">
        <div className="container-fluid d-flex justify-content-between align-items-center ">

          <Link to="/" className="navbar-brand d-flex align-items-center gap-2  my-1">
            {/* <span className="logo-text">Soulsathi.com</span> */}
            <img src={logo} className="img-fluid logo" />
          </Link>



{/* <div className="hello-box d-block d-lg-none ">
  <img
    src="http://192.168.10.227:5000/uploads/profile_images/2025/11/1764085615483-950345453.webp"
    alt="avatar"
    className="hello-avatar"
  />

  <span className="hello-text">Hello, welcome back!</span>
</div> */}




          {/* DESKTOP MENU */}
          <div className="d-none d-lg-flex align-items-center gap-4">

            <Link to="/about" className="btn topbar-link">
              <FiInfo className="me-1" /> About Us
            </Link>

            <Link to="/help" className="btn topbar-link">
              <FiHelpCircle className="me-1" /> Help
            </Link>

            {!token ? (
              <button
                className="btn topbar-btn"
                onClick={() => setShowLogin(true)}
              >
                <FiUserPlus className="me-1" /> Login / Register
              </button>
            ) : (
              <div className="position-relative">
                {/* MY ACCOUNT DROPDOWN BUTTON */}
                <button
                  className="btn topbar-link d-flex align-items-center"
                  onClick={() => setShowAccountDropdown(!showAccountDropdown)}
                >
                  <FiUser className="me-1" /> My Account
                  <FiChevronDown className="ms-1" />
                </button>

                {/* DROPDOWN MENU */}
                {showAccountDropdown && (
                  <div className="account-dropdown shadow">
                    <Link to="/my-profile" className="dropdown-item">Edit Profile</Link>
                    <Link to="/my-soulsathi" className="dropdown-item">My Matches</Link>
                    {/* <Link to="/my-soulsathi" className="dropdown-item">Dashboard</Link> */}
                    <Link to="/chats" className="dropdown-item">Messages</Link>

                    <button
                      className="dropdown-item text-danger"
                      onClick={() => setShowLogoutConfirm(true)}
                    >
                      <FiLogOut className="me-2" /> Logout
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* MOBILE MENU ICON */}
          <button
            className="btn d-lg-none menu-toggle"
            onClick={() => setMenuOpen(true)}
          >
            <FiMenu size={26} />
          </button>
        </div>
      </nav>





      

      {/* MOBILE SIDEBAR */}
      <div className={`custom-offcanvas ${isMenuOpen ? "show" : ""}`}>
        <div className="offcanvas-header d-flex justify-content-between align-items-center">

          <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
            <span className="logo-text">Soulsathi.com</span>
          </Link>

          <button className="btn-close" onClick={() => setMenuOpen(false)}>
            <FiX size={24} />
          </button>
        </div>

        <div className="offcanvas-body">
          <ul className="mobile-menu">

            <li>
              <Link to="/" onClick={() => setMenuOpen(false)}>
                <FiHome className="me-2" /> Home
              </Link>
            </li>

            <li>
              <Link to="/about" onClick={() => setMenuOpen(false)}>
                <FiInfo className="me-2" /> About Us
              </Link>
            </li>

            <li>
              <Link to="/help" onClick={() => setMenuOpen(false)}>
                <FiHelpCircle className="me-2" /> Help
              </Link>
            </li>

            {!token ? (
              <li>
                <button
                  className="mobile-btn"
                  onClick={() => {
                    setMenuOpen(false);
                    setShowLogin(true);
                  }}
                >
                  <FiUserPlus className="me-2" /> Login / Register
                </button>
              </li>
            ) : (
              <>
                <li className="mobile-dropdown-title">
                  <FiUser className="me-2" /> My Account
                </li>

                <li>
                  <Link to="/my-profile" onClick={() => setMenuOpen(false)}>
                    Edit Profile
                  </Link>
                </li>

                <li>
                  <Link to="/my-soulsathi" onClick={() => setMenuOpen(false)}>
                    Matches
                  </Link>
                </li>

                {/* <li>
                  <Link to="/my-soulsathi" onClick={() => setMenuOpen(false)}>
                    Dashboard
                  </Link>
                </li> */}

                <li>
                  <Link to="/chats" onClick={() => setMenuOpen(false)}>
                    Messages
                  </Link>
                </li>

                <li>
                  <button
                    className="mobile-btn"
                    onClick={() => {
                      setMenuOpen(false);
                      setShowLogoutConfirm(true);
                    }}
                  >
                    <FiLogOut className="me-2" /> Logout
                  </button>
                </li>
              </>
            )}

          </ul>
        </div>
      </div>

      {isMenuOpen && (
        <div className="custom-backdrop" onClick={() => setMenuOpen(false)}></div>
      )}

      {/* LOGIN MODAL */}
      <LoginModal
        show={showLogin}
        onClose={() => setShowLogin(false)}
        onLoginSuccess={() => setToken(localStorage.getItem("token"))}
      />

      {/* LOGOUT CONFIRM MODAL */}
      {showLogoutConfirm && (
        <>
          <div className="confirm-modal-backdrop"></div>

          <div className="confirm-modal-box">
            <div className="confirm-title">Logout?</div>
            <div className="confirm-text">
              Are you sure you want to log out of your account?
            </div>

            <div className="confirm-actions">
              <button
                className="confirm-btn confirm-no"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>

              <button
                className="confirm-btn confirm-yes"
                onClick={logoutNow}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </>
      )}
    </header>

    </>

  );
}

export default Topbar;
